export default class ProjectProductNotFoundError extends Error {

}